import React from 'react';
import { PHARMACY_COPY, statusLabel } from '../pharmacyCopy';

const copy = PHARMACY_COPY.ORDERS;

export const ORDER_STATUSES = ['', 'DRAFT', 'PENDING', 'VALIDATED', 'RECEIVED', 'CANCELLED'];

export const FLOW_STEPS = [
  { id: 'DRAFT', label: copy.FLOW_DRAFT },
  { id: 'PENDING', label: copy.FLOW_PENDING },
  { id: 'VALIDATED', label: copy.FLOW_VALIDATED },
  { id: 'RECEIVED', label: copy.FLOW_RECEIVED }
];

export function orderStatusClass(status) {
  if (status === 'RECEIVED') return 'cp-status-pill--ok';
  if (status === 'CANCELLED') return 'cp-status-pill--muted';
  if (status === 'VALIDATED') return 'cp-status-pill--info';
  if (status === 'PENDING') return 'cp-status-pill--warn';
  return 'cp-status-pill--muted';
}

export function nextActionLabel(status) {
  if (status === 'DRAFT') return copy.NEXT_DRAFT;
  if (status === 'PENDING') return copy.NEXT_PENDING;
  if (status === 'VALIDATED') return copy.NEXT_VALIDATED;
  if (status === 'RECEIVED') return copy.NEXT_RECEIVED;
  if (status === 'CANCELLED') return copy.NEXT_CANCELLED;
  return '';
}

function flowIndex(status) {
  if (status === 'CANCELLED') return -1;
  return FLOW_STEPS.findIndex((s) => s.id === status);
}

export function OrderFlow({ status }) {
  if (status === 'CANCELLED') {
    return (
      <div className="cp-order-flow cp-order-flow--cancelled" aria-label={copy.FLOW_TITLE}>
        <span className="cp-status-pill cp-status-pill--muted">{statusLabel('CANCELLED')}</span>
      </div>
    );
  }
  const active = flowIndex(status);
  return (
    <ol className="cp-order-flow" aria-label={copy.FLOW_TITLE}>
      {FLOW_STEPS.map((step, i) => {
        let state = 'upcoming';
        if (i < active) state = 'done';
        else if (i === active) state = 'current';
        return (
          <li key={step.id} className={`cp-order-flow__step is-${state}`}>
            <span className="cp-order-flow__dot" aria-hidden>
              {state === 'done' ? '✓' : i + 1}
            </span>
            <span className="cp-order-flow__label">{step.label}</span>
          </li>
        );
      })}
    </ol>
  );
}

export function seedReceptions(order) {
  const initial = {};
  (order.items || []).forEach((it) => {
    const remaining = Math.max(0, Number(it.quantity_ordered) - Number(it.quantity_received || 0));
    initial[it.id] = {
      quantity_received: remaining > 0 ? String(remaining) : '0',
      lot_number: it.lot_number || '',
      expiry_date: it.expiry_date ? String(it.expiry_date).slice(0, 10) : ''
    };
  });
  return initial;
}
